export default __webpack_public_path__ + "static/media/messages.970205e0.svg";